import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {CashManagementEntityModel} from "../cash-management-entity.model";
import {CashManagementSearchModel} from "../cash-management-search.model";
import {Component} from "@angular/core";
import {FUIAlertService} from "@fedeltapointofsale/ui";
import {ActionEvent} from "../../../framework/entity/action.event";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-cash-management-search-page",
    templateUrl: "./cash-management-search-page.component.html",
    providers: [provideSearchModel(CashManagementSearchModel), provideEntityModel(CashManagementEntityModel)]
})
export class CashManagementSearchPageComponent extends AbstractSearchPage {
    constructor(private alertService: FUIAlertService) {
        super();
    }

    editing(actionEvent: ActionEvent): void {
        if (!actionEvent.data.floatEnd) {
            actionEvent.preventDefault();
            this.alertService.showWarning(undefined, "wbo.cash-management.edit.message.tillStillOpenToBalance").subscribe(() => {});
        }
    }

}
